module.exports = __webpack_public_path__ + "static/media/gifdatetime.353151da.gif";